import { ProductImageTypeEnum } from '@app-graphql/schema'

export class ExposeEnums {
    ProductImageTypeEnum = ProductImageTypeEnum
}
